import { useState, useEffect } from "react";
import "./_FormTable.css";
import { Input, Select, SwitchInline } from "../../../Layout/Forms/Form";
import SerializaeHours from "./HoursList";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Request from "../../../../api/Requests";
import { useParams } from "react-router-dom";
import { Puff } from "react-loading-icons";
import { toast, ToastContainer } from "react-toastify";

const FormGuestlist = ({
    errors,
}) => {

    let params = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [formGuestlist, setFormGuestlist] = useState({
        enable: false,
        capacity: "0",
        visibility: "PUBLIC",
        blockRegistry: 0,
        task_block_registry: false,
        task_block_registry_date: "",
        automationBlockTime: "",
        promotersList: null,
        allowAppGuestList: true,
        sendSmsInvite: true,
        errors: []
    })

    useEffect(() => {
        handleGetInitialData();
    }, []);

    const handleChangeForm = (e) => {
        if (!isLoading) {
            setFormGuestlist({
                ...formGuestlist,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleGetInitialData = async () => {
        setIsLoading(true);
        const response = await Request('events/guestlist-form-info', 'GET', { event_id: params.id }, true);
        if (response && response.status) {
            setFormGuestlist({
                ...formGuestlist,
                ...response.data,
            });
        }
        setIsLoading(false);
    };

    const handleSubmitForm = async () => {
        setIsLoading(true);
        const response = await Request('events/guestlist-form-save', 'POST', { ...formGuestlist, event_id: params.id }, true);
        if (response && response.status) {
            // sucesso
            toast.success("Dados guardados com sucesso.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        } else if (response && !response.status && response.errors) {
            setFormGuestlist({
                ...formGuestlist,
                errors: response.errors,
            });
        }
        setIsLoading(false);
    };

    const InsideLoading = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    <Puff stroke="#f92056" height="5em" width="5em" />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    Loading...
                </div>
            </div>
        );
    };


    return isLoading ? (
        <InsideLoading />
    ) : (
        <div className="col-12 mt-2">
            <div className="row g-4">
                {/* Configurações de Capacidade e Horário */}
                <div className="col-12 col-lg-7">
                    <div className="campaign-card glass-glow border-0 p-4">
                        <h5 className="mb-4 d-flex align-items-center gap-2">
                            <i className="fa-solid fa-gears text-primary"></i>
                            Configurações Gerais
                        </h5>
                        <div className="row g-3">
                            <div className="col-12 col-md-6">
                                <Input
                                    label="Limite de Entradas"
                                    name="capacity"
                                    placeholder="Ex: 100 (0 = ilimitado)"
                                    value={formGuestlist.capacity}
                                    onChange={handleChangeForm}
                                    className="glass-input form-control"
                                    errors={errors}
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <Select
                                    label="Hora Limite de Entrada"
                                    name="datetimeLimit"
                                    value={formGuestlist.datetimeLimit}
                                    onChangeOption={handleChangeForm}
                                    options={SerializaeHours}
                                    className="glass-input form-control"
                                    errors={errors}
                                />
                            </div>
                            <div className="col-12 mt-3">
                                <div className="instruction-box p-3 rounded-4 border border-white border-opacity-10">
                                    <SwitchInline
                                        label="Encerrar Guest List agora"
                                        name="blockRegistry"
                                        value={formGuestlist.blockRegistry}
                                        onChangeEvent={handleChangeForm}
                                        errors={errors}
                                    />
                                    <p className="text-muted small mb-0 mt-2 opacity-75">
                                        Ative esta opção para encerrar as inscrições na guest list imediatamente.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Automação de Bloqueio */}
                <div className="col-12 col-lg-5">
                    <div className="campaign-card glass-glow border-0 p-4 h-100">
                        <h5 className="mb-4 d-flex align-items-center gap-2">
                            <i className="fa-solid fa-robot text-accent-blue"></i>
                            Automação de Bloqueio
                        </h5>

                        <div className="instruction-box p-3 rounded-4 border border-white border-opacity-10 mb-3">
                            <SwitchInline
                                label="Agendar Bloqueio Automático"
                                name="task_block_registry"
                                value={formGuestlist.task_block_registry}
                                onChangeEvent={handleChangeForm}
                                errors={errors}
                            />
                        </div>

                        {formGuestlist.task_block_registry && (
                            <div className="row g-3 animate__animated animate__fadeIn">
                                <div className="col-12 col-md-6">
                                    <Input
                                        label="Data do Bloqueio"
                                        name="task_block_registry_date"
                                        type="date"
                                        value={formGuestlist.task_block_registry_date}
                                        onChange={handleChangeForm}
                                        className="glass-input form-control"
                                        errors={errors}
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <Input
                                        label="Hora do Bloqueio"
                                        name="task_block_registry_time"
                                        type="time"
                                        value={formGuestlist.task_block_registry_time}
                                        onChange={handleChangeForm}
                                        className="glass-input form-control"
                                        errors={errors}
                                    />
                                </div>
                                <div className="col-12 mt-2">
                                    <p className="small text-muted mb-0">
                                        <i className="fa-solid fa-circle-info me-1"></i>
                                        A guest list será fechada automaticamente no horário definido.
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Preferências e Notificações */}
                <div className="col-12">
                    <div className="campaign-card glass-glow border-0 p-4">
                        <h5 className="mb-4 d-flex align-items-center gap-2">
                            <i className="fa-solid fa-bell text-warning"></i>
                            Preferências de Registo & Notificações
                        </h5>
                        <div className="row g-4">
                            <div className="col-12 col-md-6">
                                <div className="p-3 rounded-4 border border-white border-opacity-10 h-100">
                                    <SwitchInline
                                        label="Disponível na App Nightspot"
                                        name="allowAppGuestList"
                                        value={formGuestlist.allowAppGuestList}
                                        onChangeEvent={handleChangeForm}
                                        errors={errors}
                                    />
                                    <p className="text-muted small mb-0 mt-2 opacity-75">
                                        Permite que os clientes encontrem e se inscrevam no seu evento através da nossa aplicação móvel.
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="p-3 rounded-4 border border-primary border-opacity-25 h-100 position-relative animate-fade-in" style={{ background: 'rgba(99, 102, 241, 0.05)' }}>
                                    <div className="position-absolute top-0 end-0 mt-2 me-2">
                                        <i className="fa-solid fa-gem text-primary"></i>
                                    </div>
                                    <SwitchInline
                                        label={
                                            <span className="fw-bold text-white">
                                                Confirmação por SMS
                                            </span>
                                        }
                                        name="sendSmsInvite"
                                        value={formGuestlist.sendSmsInvite}
                                        onChangeEvent={handleChangeForm}
                                        errors={errors}
                                    />
                                    <div className="mt-3 ps-1">
                                        <p className="text-muted small mb-2 opacity-90" style={{ lineHeight: '1.4' }}>
                                            Envia uma mensagem automática com o QR Code para o cliente após o registo.
                                        </p>
                                        <div className="d-flex align-items-center gap-2 text-warning bg-warning bg-opacity-10 p-2 rounded-3 border border-warning border-opacity-10">
                                            <i className="fa-solid fa-coins"></i>
                                            <span className="small fw-bold">1 Crédito por registo</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12 d-flex justify-content-end">
                    <button
                        className="btn-action-primary px-4 py-3 rounded-3 fw-bold d-flex align-items-center gap-2"
                        onClick={handleSubmitForm}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                A guardar...
                            </>
                        ) : (
                            <>
                                <i className="fa-solid fa-floppy-disk"></i>
                                Guardar Dados
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FormGuestlist;
